// Copyright (c) Frisbii GmbH. All rights reserved.
"use strict";

const PgPspRequestLogsController = function ($scope, $http, PgPspRequestLogs) {
    $scope.loading = true;

    $scope.logLevels = [];
    
    $scope.pspRequestLogs = [];

    const getEmptyFilter = function () {
        return {
            Level: '',
            Message: '',
            After: '',
            Before: '',
        };
    };

    $scope.filter = getEmptyFilter();

    $scope.loadPage = function () {
        $http.get('/api/v1/paymentGateway/logs/loglevels', {cache: true}).then(function (result) {
            $scope.logLevels = result.data;
        });
    }

    $scope.loadPage();

    $scope.fetchPspRequestLogs = function () {
        $scope.loading = true;
        $scope.pspRequestLogs = $scope.paginator(function(options, callback) {
                return PgPspRequestLogs.query(options, function()
                {
                    callback();
                    $scope.loading = false;
                });
            },
            $scope.filter,
            100);
    }

    $scope.fetchPspRequestLogs();

    $scope.resetFilter = function () {
        $scope.filter = getEmptyFilter();
    };
};
PgPspRequestLogsController.$inject = ["$scope", "$http", "PgPspRequestLogs"];
